import styled from 'styled-components'

function color(props) {
  
  if (!props.theme[props.color]) {
    return 'inherit';
  }
  
  return props.theme[props.color];

}

export default styled('div')`
  position: relative;
  display: flex;
  flex: 0 1 100%;
  flex-direction: column;
  overflow-x: hidden;
  background-color: ${props => color(props)};
`
